module.exports = __webpack_public_path__ + "img/user-active.188d50b8.svg";